// removed by extract-text-webpack-plugin
module.exports = {"waterWave":"antd-pro-waterWave","text":"antd-pro-text","waterWaveCanvasWrapper":"antd-pro-waterWaveCanvasWrapper"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/Charts/WaterWave/index.less
// module id = 367
// module chunks = 0 1